import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
// import Paper from '@material-ui/core/Paper';
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import {
  AttendancePolicyData,
  CommonReducerAction,
  setHelperText,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../Assets/Images/aaa.png";
import FloatValues from "../../../../../Component/FloatValues";
import InputValues from "../../../../../Component/InputValues";
import { InitialData } from "./InitialData";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});

class TimeAtWork extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      istimeatworkrule: false,
      attendancepolicyid: null,
      isforday: false,
      isforhalfday: false,
      halfdayinhours: null,
      halfdayinpercentage: 0,
      ishalfdaypenalty: null,
      ishalfdayabsentpenalty: null,
      halfdayleaveid: { displayvalue: null, displayname: null },
      halfdayleavecount: 0,
      halfdaypenaltyactiontypeid: null,
      isforfullday: true,
      fulldayinhours: "00:00",
      fulldayinpercentage: 0,
      isfulldaypenalty: true,
      isfulldayabsentpenalty: false,
      fulldayleaveid: { displayvalue: null, displayname: null },
      fulldayleavecount: 0,
      fulldaypenaltyactiontypeid: null,
      isforweekly: false,
      weeklyhours: null,
      isweeklypenalty: null,
      weeklyleaveid: { displayvalue: null, displayname: null },
      weeklyleavecount: 0,
      weeklypenaltyactiontypeid: null,
      isformonthly: false,
      monthlyhours: null,
      ismonthlypenalty: null,
      monthlyleaveid: { displayvalue: null, displayname: null },
      monthlyleavecount: 0,
      monthlypenaltyactiontypeid: null,
      LeaveType: props.LeaveType,
      hourshalfday: 0,
      minuteshalfday: 0,
      hoursfullday: 0,
      minutesfullday: 0,
      hoursweekly: 0,
      minutesweekly: 0,
      ishalfdaypercentage: true,
      isfulldaypercentage: true,
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);
    this.props.onRef({
      onNext: this.validateNext,
    });
    this.props.ChangeLanguage("attendancepolicy,navigation");
    const timeatworkObject = this.props.InitAttendancePolicy.timeatwork;
    let halfdayleaveid;
    let fulldayleaveid;
    let weeklyleaveid;
    let monthlyleaveid;
    Object.keys(this.state).map((key) => {
      if (key == "halfdayinpercentage") {
        if (timeatworkObject[key]) {
          this.state.halfdayinpercentage = timeatworkObject[key];
          this.state.ishalfdaypercentage = true;
        } else {
          this.state.ishalfdaypercentage = false;
        }
      } else if (key == "fulldayinpercentage") {
        if (timeatworkObject[key]) {
          this.state.fulldayinpercentage = timeatworkObject[key];
          this.state.isfulldaypercentage = true;
        } else {
          this.state.isfulldaypercentage = false;
        }
      } else if (key == "halfdayleaveid") {
        halfdayleaveid = this.state.LeaveType.find(
          (x) => x.displayvalue == timeatworkObject[key],
        );
      } else if (key == "fulldayleaveid") {
        fulldayleaveid = this.state.LeaveType.find(
          (x) => x.displayvalue == timeatworkObject[key],
        );
      } else if (key == "weeklyleaveid") {
        weeklyleaveid = this.state.LeaveType.find(
          (x) => x.displayvalue == timeatworkObject[key],
        );
      } else if (key == "monthlyleaveid") {
        monthlyleaveid = this.state.LeaveType.find(
          (x) => x.displayvalue == timeatworkObject[key],
        );
      } else if (key == "halfdayinhours") {
        if (timeatworkObject[key]) {
          const hoursminutes = timeatworkObject[key].split(":");
          this.state.hourshalfday = hoursminutes[0];
          this.state.minuteshalfday = hoursminutes[1];
        }
      } else if (key == "fulldayinhours") {
        if (timeatworkObject[key]) {
          const hoursminutes = timeatworkObject[key].split(":");
          this.state.hoursfullday = hoursminutes[0];
          this.state.minutesfullday = hoursminutes[1];
        }
      } else if (key == "weeklyhours") {
        if (timeatworkObject[key]) {
          const hoursminutes = timeatworkObject[key].split(":");
          this.state.hoursweekly = hoursminutes[0];
          this.state.minutesweekly = hoursminutes[1];
        }
      } else {
        this.state[key] =
          timeatworkObject[key] !== undefined
            ? timeatworkObject[key]
            : this.state[key];
      }
    });
    this.setState({
      halfdayleaveid,
      fulldayleaveid,
      weeklyleaveid,
      monthlyleaveid,
      istimeatworkrule: this.props.InitAttendancePolicy.istimeatworkrule,
    });
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  validateNext = () => {
    let isError = false;
    if (this.state.istimeatworkrule) {
      if (!this.state.isforday && !this.state.isforweekly) {
        this.showError("Please select absenteeism type weekly or daily");
        isError = true;
      } else {
        if (this.state.isforday) {
          if (!this.state.isforhalfday && !this.state.isforfullday) {
            this.showError("Please select half day or full day");
            isError = true;
          }
          if (this.state.isforhalfday) {
            if (this.state.ishalfdaypenalty) {
              if (!this.state.halfdayleaveid) {
                this.showError("Please select leave type for half day");
                isError = true;
              } else if (this.state.ishalfdaypercentage) {
                if (this.state.halfdayinpercentage < 1) {
                  this.showError("Please select shift percentage for half day");
                  isError = true;
                }
              } else if (
                Number(this.state.hourshalfday) < 1 &&
                Number(this.state.minuteshalfday) < 1
              ) {
                this.showError("Please select half day hours");
                isError = true;
              } else if (this.state.halfdayleavecount == 0) {
                this.showError("Please add leave count for half day");
                isError = true;
              } else if (!this.state.halfdaypenaltyactiontypeid) {
                this.showError("Please select a deduction policy for half day");
                isError = true;
              }
            }
          }
          if (this.state.isforfullday) {
            if (this.state.isfulldaypenalty) {
              if (!this.state.fulldayleaveid) {
                this.showError("Please select leave type for full day");
                isError = true;
              } else if (this.state.isfulldaypercentage) {
                if (this.state.fulldayinpercentage < 1) {
                  this.showError("Please select shift percentage for full day");
                  isError = true;
                }
              } else if (
                Number(this.state.hoursfullday) < 1 &&
                Number(this.state.minutesfullday) < 1
              ) {
                this.showError("Please select full day hours");
                isError = true;
              } else if (this.state.fulldayleavecount == 0) {
                this.showError("Please add a leave count for full day");
                isError = true;
              } else if (!this.state.fulldaypenaltyactiontypeid) {
                this.showError("Please select a deduction policy for full day");
                isError = true;
              }
            }
          }
        }

        if (this.state.isforweekly) {
          if (
            Number(this.state.minutesweekly) < 1 &&
            Number(this.state.hoursweekly) < 1
          ) {
            this.showError(
              "Please add hours and minutes for weekly time at work",
            );
            isError = true;
          } else if (this.state.isweeklypenalty) {
            if (!this.state.weeklyleaveid) {
              this.showError(
                "Please select leave type for weekly time at work",
              );
              isError = true;
            } else if (this.state.weeklyleavecount == 0) {
              this.showError("Please add leave count for weekly time at work");
              isError = true;
            } else if (!this.state.weeklypenaltyactiontypeid) {
              this.showError(
                "Please select a deduction policy for weekly time at work",
              );
              isError = true;
            }
          }
        }
      }
    }
    this.props.StepError(5, isError);

    if (isError) return false;
    this.props.click();
  };

  showError = (error) => {
    this.props.enqueueSnackbar(error, { variant: "error" });
  };

  handleChange(name, arg, event) {
    switch (name) {
      case "istimeatworkrule": {
        if (arg == this.state.istimeatworkrule) return false;
        this.setState({ istimeatworkrule: arg }, () => {
          !this.state.istimeatworkrule ? this.ClearAll() : this.UpdateReducer();
        });
        break;
      }
      case "isweeklypenalty":
        {
          const newStateObject = {
            weeklyleaveid: null,
            weeklyleavecount: 0,
            weeklypenaltyactiontypeid: null,
          };
          if (arg == this.state.isweeklypenalty) return false;
          this.setState({ isweeklypenalty: arg }, () => {
            !this.state.isweeklypenalty
              ? this.setState({ ...newStateObject }, () => this.UpdateReducer())
              : this.UpdateReducer();
          });
        }
        break;
      case "isfulldaypenalty":
        {
          const newStateObject = {
            fulldayleaveid: null,
            fulldayleavecount: 0,
            fulldaypenaltyactiontypeid: null,
          };
          if (arg == this.state[name]) return false;
          this.setState({ [name]: arg, isfulldayabsentpenalty: false }, () => {
            !this.state[name]
              ? this.setState({ ...newStateObject }, () => this.UpdateReducer())
              : this.UpdateReducer();
          });
        }
        break;
      case "ishalfdaypenalty":
        {
          const newStateObject = {
            halfdayleaveid: null,
            halfdayleavecount: 0,
            halfdaypenaltyactiontypeid: null,
          };
          if (arg == this.state[name]) return false;
          this.setState({ [name]: arg, ishalfdayabsentpenalty: false }, () => {
            !this.state[name]
              ? this.setState({ ...newStateObject }, () => this.UpdateReducer())
              : this.UpdateReducer();
          });
        }
        break;
      case "ishalfdayabsentpenalty":
        {
          const newStateObject = {
            halfdayleaveid: null,
            halfdayleavecount: 0,
            halfdaypenaltyactiontypeid: null,
          };
          if (arg == this.state[name]) return false;
          this.setState({ [name]: arg, ishalfdaypenalty: null }, () => {
            this.UpdateReducer();
          });
        }
        break;
      case "isfulldayabsentpenalty":
        {
          const newStateObject = {
            halfdayleaveid: null,
            halfdayleavecount: 0,
            halfdaypenaltyactiontypeid: null,
          };
          if (arg == this.state[name]) return false;
          this.setState({ [name]: arg, isfulldaypenalty: null }, () => {
            this.UpdateReducer();
          });
        }
        break;
      case "isforhalfday":
        {
          const newStateObject = {
            hourshalfday: 0,
            minuteshalfday: 0,
            halfdayinpercentage: 0,
            ishalfdaypenalty: null,
            halfdayleaveid: null,
            halfdayleavecount: 0,
            halfdaypenaltyactiontypeid: null,
          };
          this.setState({ isforhalfday: arg }, () => {
            !this.state.isforhalfday
              ? this.setState({ ...newStateObject }, () => this.UpdateReducer())
              : this.UpdateReducer();
          });
        }
        break;
      case "isforfullday":
        {
          const newStateObject = {
            hoursfullday: 0,
            minutesfullday: 0,
            fulldayinpercentage: 0,
            isfulldaypenalty: null,
            fulldayleaveid: null,
            fulldayleavecount: 0,
            fulldaypenaltyactiontypeid: null,
          };
          this.setState({ isforfullday: arg }, () => {
            !this.state.isforfullday
              ? this.setState({ ...newStateObject }, () => this.UpdateReducer())
              : this.UpdateReducer();
          });
        }
        break;
      case "isforweekly":
        {
          const newStateObject = {
            hoursweekly: 0,
            minutesweekly: 0,
            isweeklypenalty: null,
            weeklyleaveid: null,
            weeklyleavecount: 0,
            weeklypenaltyactiontypeid: null,
          };
          this.setState({ isforweekly: arg }, () => {
            !this.state.isforweekly
              ? this.setState({ ...newStateObject }, () => this.UpdateReducer())
              : this.UpdateReducer();
          });
        }
        break;
      case "ishalfdaypercentage":
      case "isfulldaypercentage": {
        const newStateObject = {};
        switch (name) {
          case "ishalfdaypercentage":
            Object.assign(newStateObject, {
              halfdayinpercentage: 0,
              hourshalfday: 0,
              minuteshalfday: 0,
            });
            break;
          case "isfulldaypercentage":
            Object.assign(newStateObject, {
              fulldayinpercentage: 0,
              hoursfullday: 0,
              minutesfullday: 0,
            });
            break;
          default:
            break;
        }
        this.setState({ [name]: arg, ...newStateObject }, () => {
          this.UpdateReducer();
        });
        break;
      }
      // case "weeklyhours":
      // case "fulldayinhours":
      // case "halfdayinhours":
      case "halfdayinpercentage":
      case "fulldayinpercentage":
      case "halfdayleavecount":
      case "fulldayleavecount":
      case "weeklyleavecount":
        this.CommonNumberChange(name, arg, event);
        break;
      case "hourshalfday":
      case "hoursfullday":
      case "hoursweekly":
      case "minutesfullday":
      case "minuteshalfday":
      case "minutesweekly": {
        this.HourMinuteKeyChange(name, arg, event);
        break;
      }
      case "isforday": {
        this.setState({ [name]: arg }, () => {
          if (!this.state.isforday) {
            this.handleChange("isforfullday", false);
            this.handleChange("isforhalfday", false);
          }
          this.UpdateReducer();
        });
        break;
      }
      case "weeklyleaveid":
      case "halfdayleaveid":
      case "fulldayleaveid":
      case "halfdaypenaltyactiontypeid":
      case "fulldaypenaltyactiontypeid":
      case "weeklypenaltyactiontypeid": {
        this.setState({ [name]: arg }, () => this.UpdateReducer());
        break;
      }
      default:
        break;
    }
  }

  CommonNumberChange = (name, max, event) => {
    let value;
    if (
      Number(event.target.value) > Number(max) ||
      Number.isNaN(event.target.value) ||
      Math.sign(event.target.value) == -1
    ) {
      value = this.state[name];
    } else value = event.target.value;

    this.setState({ [name]: Number(value) }, () => this.UpdateReducer());
  };

  HourMinuteKeyChange = (name, max, event) => {
    const numbers = /^[0-9]+$/;
    if (event.target.value.match(numbers)) {
      let value;
      if (Number(event.target.value) > Number(max)) value = this.state[name];
      else {
        value = Number(event.target.value);
        if (value < 10) {
          value = `0${value}`;
        }
      }
      // value > 9 ? value = value : value = `${value}`

      this.setState({ [name]: parseInt(value) }, () => this.UpdateReducer());
    }
  };

  ClearAll = () => {
    this.setState(
      {
        ...InitialData.timeatwork,
      },
      () => this.UpdateReducer(),
    );
  };

  UpdateReducer = () => {
    this.props.AttendancePolicyData({
      ...this.props.InitAttendancePolicy,
      istimeatworkrule: this.state.istimeatworkrule,
      timeatwork: {
        // istimeatworkrule: this.state.istimeatworkrule,
        attendancepolicyid: this.state.attendancepolicyid,
        isforday: this.state.isforday,
        isforhalfday: this.state.isforhalfday,
        halfdayinhours: `${this.state.hourshalfday}:${this.state.minuteshalfday}`,
        halfdayinpercentage: this.state.halfdayinpercentage,
        ishalfdaypenalty: this.state.ishalfdaypenalty,
        ishalfdayabsentpenalty: this.state.ishalfdayabsentpenalty,
        halfdayleaveid: this.state.halfdayleaveid
          ? this.state.halfdayleaveid.displayvalue
          : null,
        halfdayleavename: this.state.halfdayleaveid
          ? this.state.halfdayleaveid.displayname
          : null,
        halfdayleavecount: this.state.halfdayleavecount,
        halfdaypenaltyactiontypeid: this.state.halfdaypenaltyactiontypeid,
        isforfullday: this.state.isforfullday,
        fulldayinhours: `${this.state.hoursfullday}:${this.state.minutesfullday}`,
        fulldayinpercentage: this.state.fulldayinpercentage,
        isfulldaypenalty: this.state.isfulldaypenalty,
        isfulldayabsentpenalty: this.state.isfulldayabsentpenalty,
        fulldayleaveid: this.state.fulldayleaveid
          ? this.state.fulldayleaveid.displayvalue
          : null,
        fulldayleavename: this.state.fulldayleaveid
          ? this.state.fulldayleaveid.displayname
          : null,
        fulldayleavecount: this.state.fulldayleavecount,
        fulldaypenaltyactiontypeid: this.state.fulldaypenaltyactiontypeid,
        isforweekly: this.state.isforweekly,
        weeklyhours: `${this.state.hoursweekly}:${this.state.minutesweekly}`,
        isweeklypenalty: this.state.isweeklypenalty,
        weeklyleaveid: this.state.weeklyleaveid
          ? this.state.weeklyleaveid.displayvalue
          : null,
        weeklyleavename: this.state.weeklyleaveid
          ? this.state.weeklyleaveid.displayname
          : null,
        weeklyleavecount: this.state.weeklyleavecount,
        weeklypenaltyactiontypeid: this.state.weeklypenaltyactiontypeid,
        isformonthly: this.state.isformonthly,
        monthlyhours: this.state.monthlyhours,
        ismonthlypenalty: this.state.ismonthlypenalty,
        monthlyleaveid: this.state.monthlyleaveid
          ? this.state.monthlyleaveid.displayvalue
          : null,
        monthlyleavename: this.state.monthlyleaveid
          ? this.state.monthlyleaveid.displayname
          : null,
        monthlyleavecount: this.state.monthlyleavecount,
        monthlypenaltyactiontypeid: this.state.monthlypenaltyactiontypeid,
      },
    });
  };

  render() {
    const language = this.props.Language.attendancepolicy;

    return (
      <IntlProvider locale="en" messages={language}>
        <div className="stepper-scroller padding-top-0">
          <div className="padding-bottom-30 stepper-scroller-content width80">
            <p className="input-form-label"></p>
            <div className=" padding-bottom-30 inner-wrapper opaque">
              <p className="depedent-select-list-head margin-top-30">
                <FormattedMessage
                  id="LbTAWDoYouWishAction"
                  defaultMessage="Do you wish to set time at work requirements for your company? Here you can specify number of hours an employee needs to be at-work in order to meet the company's attendance expectations."
                />
              </p>
              <div>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("istimeatworkrule", true)}
                  aria-expanded={this.state.istimeatworkrule}
                >
                  <div style={{ width: "95%", display: "inline-block" }}>
                    <FormattedMessage
                      id="LbMinHoursPenalty"
                      defaultMessage="Yes, employees are required to work minimum hours, and penalties will be set for not meeting this requirement"
                    />
                  </div>
                  {this.state.istimeatworkrule ? (
                    <div
                      style={{ display: "inline-block" }}
                      className="floatright"
                    >
                      <img src={CheckImg} height="20" />
                    </div>
                  ) : (
                    <div className="not-selected"></div>
                  )}
                </div>
                <div className="et-level2">
                  <Collapse
                    in={this.state.istimeatworkrule}
                    timeout={2}
                    unmountOnExit
                    className="padding30 overflow-initial"
                  >
                    <div
                      className="depedent-select-list"
                      onClick={() =>
                        this.handleChange("isforday", !this.state.isforday)
                      }
                      aria-expanded={this.state.isforday}
                    >
                      <span>
                        <FormattedMessage
                          id="LbMinHours"
                          defaultMessage="Employees are required to work minimum hours, every day"
                        />
                      </span>
                      {this.state.isforday ? (
                        <span className="floatright selected-box">
                          {" "}
                          <svg width="24" height="24" viewBox="0 0 24 24">
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                          </svg>
                        </span>
                      ) : (
                        <span className="not-selected-box"></span>
                      )}
                    </div>
                    <div className="et-level3">
                      <Collapse
                        in={this.state.isforday}
                        timeout={2}
                        unmountOnExit
                        className="padding30 overflow-initial"
                      >
                        <div
                          className="depedent-select-list"
                          onClick={() =>
                            this.handleChange(
                              "isforhalfday",
                              !this.state.isforhalfday,
                            )
                          }
                          aria-expanded={this.state.isforhalfday}
                        >
                          <div
                            style={{ width: "94%", display: "inline-block" }}
                          >
                            <FormattedMessage
                              id="LbRequiredTAW"
                              defaultMessage="Required time-at-work or hours for Half-working day, and penalty (if any) in case of deficit"
                            />
                          </div>
                          {this.state.isforhalfday ? (
                            <div
                              style={{ display: "inline-block" }}
                              className="floatright selected-box"
                            >
                              {" "}
                              <svg width="24" height="24" viewBox="0 0 24 24">
                                <path d="M0 0h24v24H0z" fill="none" />
                                <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                              </svg>
                            </div>
                          ) : (
                            <div className="not-selected-box"></div>
                          )}
                        </div>
                        <div className="et-level4">
                          <Collapse
                            in={this.state.isforhalfday}
                            timeout={2}
                            unmountOnExit
                            className="padding30 overflow-initial"
                          >
                            <ul>
                              <li>
                                <span className="display-block margin-bottom-8">
                                  <FormattedMessage
                                    id="LbMinimumHalfDay"
                                    defaultMessage="Minimum duration required to count the work-day as a Half day"
                                  />
                                </span>
                                <ul className="padding0">
                                  <div
                                    className="depedent-select-list"
                                    aria-expanded={
                                      this.state.ishalfdaypercentage
                                    }
                                  >
                                    <span className="width200p">
                                      <InputValues
                                        min="0"
                                        max={
                                          this.state.isforfullday
                                            ? this.state.fulldayinpercentage
                                            : "100"
                                        }
                                        field="halfdayinpercentage"
                                        onChange={this.handleChange.bind(
                                          this,
                                          "halfdayinpercentage",
                                          this.state.isforfullday
                                            ? this.state.fulldayinpercentage
                                            : "100",
                                        )}
                                        value={this.state.halfdayinpercentage}
                                        defaultvalue={
                                          this.state.halfdayinpercentage
                                        }
                                        disabled={
                                          !this.state.ishalfdaypercentage
                                        }
                                      />
                                    </span>
                                    <FormattedMessage
                                      id="LbPercentofShift"
                                      defaultMessage="% of Shift's total duration"
                                    />
                                    {this.state.ishalfdaypercentage ? (
                                      <span className="floatright margin-top-20">
                                        <img src={CheckImg} height="20" />
                                      </span>
                                    ) : (
                                      <span
                                        onClick={() =>
                                          this.handleChange(
                                            "ishalfdaypercentage",
                                            true,
                                          )
                                        }
                                        className="not-selected margin-top-20"
                                      ></span>
                                    )}
                                  </div>
                                  <div
                                    className="depedent-select-list"
                                    aria-expanded={
                                      !this.state.ishalfdaypercentage
                                    }
                                  >
                                    <span className="width200p">
                                      <InputValues
                                        min="0"
                                        max={
                                          this.state.isforfullday
                                            ? this.state.hoursfullday
                                            : "23"
                                        }
                                        field="hourshalfday"
                                        onChange={this.handleChange.bind(
                                          this,
                                          "hourshalfday",
                                          this.state.isforfullday
                                            ? this.state.hoursfullday
                                            : "23",
                                        )}
                                        value={this.state.hourshalfday}
                                        defaultvalue={this.state.hourshalfday}
                                        disabled={
                                          this.state.ishalfdaypercentage
                                        }
                                      />
                                    </span>
                                    <FormattedMessage
                                      id="LbHours"
                                      defaultMessage="hours"
                                    />
                                    <InputValues
                                      min="0"
                                      max={
                                        this.state.isforfullday
                                          ? this.state.minutesfullday
                                          : "59"
                                      }
                                      field="minuteshalfday"
                                      onChange={this.handleChange.bind(
                                        this,
                                        "minuteshalfday",
                                        this.state.isforfullday
                                          ? this.state.minutesfullday
                                          : "59",
                                      )}
                                      value={this.state.minuteshalfday}
                                      defaultvalue={this.state.minuteshalfday}
                                      disabled={this.state.ishalfdaypercentage}
                                    />

                                    <FormattedMessage
                                      id="LbMinutes"
                                      defaultMessage="minutes"
                                    />
                                    {!this.state.ishalfdaypercentage ? (
                                      <span className="floatright margin-top-20">
                                        <img src={CheckImg} height="20" />
                                      </span>
                                    ) : (
                                      <span
                                        onClick={() =>
                                          this.handleChange(
                                            "ishalfdaypercentage",
                                            false,
                                          )
                                        }
                                        className="not-selected margin-top-20"
                                      ></span>
                                    )}
                                  </div>
                                </ul>
                              </li>
                              <li className="margin-top-20">
                                <span className="display-block margin-bottom-8">
                                  <FormattedMessage
                                    id="LbDoYouWantLeaves"
                                    defaultMessage="Do you want to deduct leaves as penalty if the employee is unable to complete the required minimum hours for Half-working day?"
                                  />
                                </span>
                                <div
                                  className="depedent-select-list"
                                  onClick={() =>
                                    this.handleChange("ishalfdaypenalty", true)
                                  }
                                  aria-expanded={this.state.ishalfdaypenalty}
                                >
                                  <span>
                                    <FormattedMessage
                                      id="LbYes"
                                      defaultMessage="Yes"
                                    />
                                  </span>
                                  {this.state.ishalfdaypenalty == true ? (
                                    <span className="floatright">
                                      <img src={CheckImg} height="20" />
                                    </span>
                                  ) : (
                                    <span className="not-selected"></span>
                                  )}
                                </div>
                                <Collapse
                                  in={this.state.ishalfdaypenalty}
                                  timeout={2}
                                  unmountOnExit
                                  className="padding30 overflow-initial"
                                >
                                  <ul>
                                    <li>
                                      <p className="form-input-label">
                                        <FormattedMessage
                                          id="LbChooseleavetype"
                                          defaultMessage="Choose leave type "
                                        />
                                      </p>
                                      <span className="width200p">
                                        <Select
                                          autofocus
                                          placeholder="Select"
                                          options={this.state.LeaveType}
                                          getOptionLabel={(option) =>
                                            option.displayname
                                          }
                                          getOptionValue={(option) =>
                                            option.displayvalue
                                          }
                                          onChange={this.handleChange.bind(
                                            this,
                                            "halfdayleaveid",
                                          )}
                                          value={this.state.halfdayleaveid}
                                          className="width200p"
                                        />
                                      </span>
                                    </li>
                                    <li className="margin-top-20">
                                      <p className="form-input-label">
                                        <FormattedMessage
                                          id="LbNumberLeaveDeduct"
                                          defaultMessage="Number of leaves to deduct"
                                        />
                                      </p>
                                      <FloatValues
                                        min="0"
                                        max="31"
                                        step="0.25"
                                        field="halfdayleavecount"
                                        onChange={this.handleChange.bind(
                                          this,
                                          "halfdayleavecount",
                                          31,
                                        )}
                                        value={this.state.halfdayleavecount}
                                        defaultvalue={
                                          this.state.halfdayleavecount
                                        }
                                      />
                                    </li>
                                    <li className="margin-top-10">
                                      <p className="form-input-label">
                                        <FormattedMessage
                                          id="LbDeductionPolicy"
                                          defaultMessage="Deduction Policy"
                                        />
                                      </p>
                                      {/* <ul className="padding-left-20">
                                                                            <li> */}
                                      <div
                                        className="depedent-select-list"
                                        onClick={() =>
                                          this.handleChange(
                                            "halfdaypenaltyactiontypeid",
                                            1,
                                          )
                                        }
                                        aria-expanded={
                                          this.state
                                            .halfdaypenaltyactiontypeid == 1
                                        }
                                      >
                                        <div
                                          style={{
                                            width: "90%",
                                            display: "inline-block",
                                          }}
                                        >
                                          <FormattedMessage
                                            id="LbAutoDeductLeave"
                                            defaultMessage="Automatically send a leave request on behalf of the employee, using the regular Leave approval workflow"
                                          />
                                        </div>
                                        {this.state
                                          .halfdaypenaltyactiontypeid == 1 ? (
                                          <div
                                            style={{ display: "inline-block" }}
                                            className="floatright margin-top-20"
                                          >
                                            <img src={CheckImg} height="20" />
                                          </div>
                                        ) : (
                                          <div className="not-selected margin-top-20"></div>
                                        )}
                                      </div>
                                      {/* </li>
                                                                            <li> */}
                                      <div
                                        className="depedent-select-list"
                                        onClick={() =>
                                          this.handleChange(
                                            "halfdaypenaltyactiontypeid",
                                            2,
                                          )
                                        }
                                        aria-expanded={
                                          this.state
                                            .halfdaypenaltyactiontypeid == 2
                                        }
                                      >
                                        <div
                                          style={{
                                            width: "90%",
                                            display: "inline-block",
                                          }}
                                        >
                                          <FormattedMessage
                                            id="LbExceedingGraceHours"
                                            defaultMessage="Deduct automatically and notify employee, approvers and admin"
                                          />
                                        </div>
                                        {this.state
                                          .halfdaypenaltyactiontypeid == 2 ? (
                                          <div
                                            style={{ display: "inline-block" }}
                                            className="floatright margin-top-10"
                                          >
                                            <img src={CheckImg} height="20" />
                                          </div>
                                        ) : (
                                          <div className="not-selected margin-top-10"></div>
                                        )}
                                      </div>
                                      {/* </li>
                                                                        </ul> */}
                                    </li>
                                  </ul>
                                </Collapse>
                                <div
                                  className="depedent-select-list display-flex"
                                  onClick={() =>
                                    this.handleChange("ishalfdaypenalty", false)
                                  }
                                  aria-expanded={
                                    this.state.ishalfdaypenalty == false
                                  }
                                >
                                  <span>
                                    No (Manager will be notified about this
                                    breach but no action will be taken)
                                  </span>
                                  {this.state.ishalfdaypenalty == false ? (
                                    <span className="floatright">
                                      <img src={CheckImg} height="20" />
                                    </span>
                                  ) : (
                                    <span className="not-selected"></span>
                                  )}
                                </div>
                                <div
                                  className="depedent-select-list display-flex"
                                  onClick={() =>
                                    this.handleChange(
                                      "ishalfdayabsentpenalty",
                                      true,
                                    )
                                  }
                                  aria-expanded={
                                    this.state.ishalfdayabsentpenalty
                                  }
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <span>No (Mark the employee as absent)</span>
                                  {this.state.ishalfdayabsentpenalty ? (
                                    <span className="floatright">
                                      <img src={CheckImg} height="20" />
                                    </span>
                                  ) : (
                                    <span className="not-selected"></span>
                                  )}
                                </div>
                              </li>
                            </ul>
                          </Collapse>
                        </div>
                        <div
                          className="depedent-select-list"
                          onClick={() =>
                            this.handleChange(
                              "isforfullday",
                              !this.state.isforfullday,
                            )
                          }
                          aria-expanded={this.state.isforfullday}
                        >
                          <div
                            style={{ width: "95%", display: "inline-block" }}
                          >
                            <FormattedMessage
                              id="LbForFullWorking"
                              defaultMessage="Required time-at-work or hours for Full-working day, and penalty (if any) in case of deficit"
                            />
                          </div>
                          {this.state.isforfullday ? (
                            <div
                              style={{ display: "inline-block" }}
                              className="floatright selected-box"
                            >
                              {" "}
                              <svg width="24" height="24" viewBox="0 0 24 24">
                                <path d="M0 0h24v24H0z" fill="none" />
                                <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                              </svg>
                            </div>
                          ) : (
                            <div className="not-selected-box"></div>
                          )}
                        </div>
                        <div className="et-level4">
                          <Collapse
                            in={this.state.isforfullday}
                            timeout={2}
                            unmountOnExit
                            className="padding30 overflow-initial"
                          >
                            <ul>
                              <li>
                                <span className="display-block margin-bottom-8">
                                  <FormattedMessage
                                    id="LbMinimumFullDay"
                                    defaultMessage="Minimum duration required to count the work-day as a Full day"
                                  />
                                </span>
                                <ul className="padding0">
                                  <div
                                    className="depedent-select-list"
                                    aria-expanded={
                                      this.state.isfulldaypercentage
                                    }
                                  >
                                    <span className="width200p">
                                      <InputValues
                                        min="0"
                                        max="100"
                                        field="fulldayinpercentage"
                                        onChange={this.handleChange.bind(
                                          this,
                                          "fulldayinpercentage",
                                          100,
                                        )}
                                        value={this.state.fulldayinpercentage}
                                        disabled={
                                          !this.state.isfulldaypercentage
                                        }
                                        defaultvalue={
                                          this.state.fulldayinpercentage
                                        }
                                      />
                                    </span>
                                    <FormattedMessage
                                      id="LbPercentofShift"
                                      defaultMessage="% of Shift's total duration"
                                    />
                                    {this.state.isfulldaypercentage ? (
                                      <span className="floatright margin-top-10">
                                        <img src={CheckImg} height="20" />
                                      </span>
                                    ) : (
                                      <span
                                        onClick={() =>
                                          this.handleChange(
                                            "isfulldaypercentage",
                                            true,
                                          )
                                        }
                                        className="not-selected margin-top-10"
                                      ></span>
                                    )}
                                  </div>
                                  <div
                                    className="depedent-select-list"
                                    aria-expanded={
                                      !this.state.isfulldaypercentage
                                    }
                                  >
                                    <span className="width200p">
                                      <InputValues
                                        min="0"
                                        max="23"
                                        field="hoursfullday"
                                        onChange={this.handleChange.bind(
                                          this,
                                          "hoursfullday",
                                          23,
                                        )}
                                        value={this.state.hoursfullday}
                                        defaultvalue={this.state.hoursfullday}
                                        disabled={
                                          this.state.isfulldaypercentage
                                        }
                                      />
                                    </span>
                                    <FormattedMessage
                                      id="LbHours"
                                      defaultMessage="hours"
                                    />
                                    <InputValues
                                      min="0"
                                      max="59"
                                      field="minutesfullday"
                                      onChange={this.handleChange.bind(
                                        this,
                                        "minutesfullday",
                                        59,
                                      )}
                                      value={this.state.minutesfullday}
                                      disabled={this.state.isfulldaypercentage}
                                      defaultvalue={this.state.minutesfullday}
                                    />

                                    <FormattedMessage
                                      id="LbMinutes"
                                      defaultMessage="minutes"
                                    />
                                    {!this.state.isfulldaypercentage ? (
                                      <span className="floatright margin-top-10">
                                        <img src={CheckImg} height="20" />
                                      </span>
                                    ) : (
                                      <span
                                        onClick={() =>
                                          this.handleChange(
                                            "isfulldaypercentage",
                                            false,
                                          )
                                        }
                                        className="not-selected margin-top-10"
                                      ></span>
                                    )}
                                  </div>
                                </ul>
                              </li>
                              <li className="margin-top-20">
                                <span className="display-block margin-bottom-8">
                                  <FormattedMessage
                                    id="LbDoYouWantDeductFullWork"
                                    defaultMessage="Do you want to deduct leaves as penalty if the employee is unable to complete the required minimum hours for Full-working day?"
                                  />
                                </span>
                                <div
                                  className="depedent-select-list"
                                  onClick={() =>
                                    this.handleChange("isfulldaypenalty", true)
                                  }
                                  aria-expanded={this.state.isfulldaypenalty}
                                >
                                  <span>
                                    <FormattedMessage
                                      id="LbYes"
                                      defaultMessage="Yes"
                                    />
                                  </span>
                                  {this.state.isfulldaypenalty ? (
                                    <span className="floatright">
                                      <img src={CheckImg} height="20" />
                                    </span>
                                  ) : (
                                    <span className="not-selected"></span>
                                  )}
                                </div>
                                <Collapse
                                  in={this.state.isfulldaypenalty}
                                  timeout={2}
                                  unmountOnExit
                                  className="padding30 overflow-initial"
                                >
                                  <ul>
                                    <li>
                                      <p className="form-input-label">
                                        <FormattedMessage
                                          id="LbChooseleavetype"
                                          defaultMessage="Choose leave type "
                                        />
                                      </p>
                                      <span className="width200p">
                                        <Select
                                          autofocus
                                          placeholder="Select"
                                          options={this.state.LeaveType}
                                          getOptionLabel={(option) =>
                                            option.displayname
                                          }
                                          getOptionValue={(option) =>
                                            option.displayvalue
                                          }
                                          onChange={this.handleChange.bind(
                                            this,
                                            "fulldayleaveid",
                                          )}
                                          value={this.state.fulldayleaveid}
                                          className="width200p"
                                        />
                                      </span>
                                    </li>
                                    <li className="margin-top-10">
                                      <p className="form-input-label">
                                        <FormattedMessage
                                          id="LbNumberLeaveDeduct"
                                          defaultMessage="Number of leaves to deduct"
                                        />
                                      </p>
                                      <FloatValues
                                        min="0"
                                        max="31"
                                        step="0.25"
                                        field="fulldayleavecount"
                                        onChange={this.handleChange.bind(
                                          this,
                                          "fulldayleavecount",
                                          31,
                                        )}
                                        value={this.state.fulldayleavecount}
                                        defaultvalue={
                                          this.state.fulldayleavecount
                                        }
                                      />
                                    </li>
                                    <li className="margin-top-10">
                                      <p className="form-input-label">
                                        <FormattedMessage
                                          id="LbDeductionPolicy"
                                          defaultMessage="Deduction Policy"
                                        />
                                      </p>
                                      {/* <ul className="padding-left-20">
                                                                            <li> */}
                                      <div
                                        className="depedent-select-list"
                                        onClick={() =>
                                          this.handleChange(
                                            "fulldaypenaltyactiontypeid",
                                            1,
                                          )
                                        }
                                        aria-expanded={
                                          this.state
                                            .fulldaypenaltyactiontypeid == 1
                                        }
                                      >
                                        <div
                                          style={{
                                            width: "90%",
                                            display: "inline-block",
                                          }}
                                        >
                                          <FormattedMessage
                                            id="LbAutoDeductLeave"
                                            defaultMessage="Automatically send a leave request on behalf of the employee, using the regular Leave approval workflow"
                                          />
                                        </div>
                                        {this.state
                                          .fulldaypenaltyactiontypeid == 1 ? (
                                          <div
                                            style={{ display: "inline-block" }}
                                            className="floatright margin-top-20"
                                          >
                                            <img src={CheckImg} height="20" />
                                          </div>
                                        ) : (
                                          <div className="not-selected margin-top-20"></div>
                                        )}
                                      </div>
                                      {/* </li>
                                                                            <li> */}
                                      <div
                                        className="depedent-select-list"
                                        onClick={() =>
                                          this.handleChange(
                                            "fulldaypenaltyactiontypeid",
                                            2,
                                          )
                                        }
                                        aria-expanded={
                                          this.state
                                            .fulldaypenaltyactiontypeid == 2
                                        }
                                      >
                                        <div
                                          style={{
                                            width: "90%",
                                            display: "inline-block",
                                          }}
                                        >
                                          <FormattedMessage
                                            id="LbExceedingGraceHours"
                                            defaultMessage="Deduct automatically and notify employee, approvers and admin"
                                          />
                                        </div>
                                        {this.state
                                          .fulldaypenaltyactiontypeid == 2 ? (
                                          <div
                                            style={{ display: "inline-block" }}
                                            className="floatright margin-top-10"
                                          >
                                            <img src={CheckImg} height="20" />
                                          </div>
                                        ) : (
                                          <div className="not-selected margin-top-10"></div>
                                        )}
                                      </div>
                                      {/* </li>
                                                                        </ul> */}
                                    </li>
                                  </ul>
                                </Collapse>
                                <div
                                  className="depedent-select-list display-flex"
                                  onClick={() =>
                                    this.handleChange("isfulldaypenalty", false)
                                  }
                                  aria-expanded={
                                    this.state.isfulldaypenalty == false
                                  }
                                >
                                  <span>
                                    No (Manager will be notified about this
                                    breach but no action will be taken)
                                  </span>
                                  {this.state.isfulldaypenalty == false ? (
                                    <span className="floatright">
                                      <img src={CheckImg} height="20" />
                                    </span>
                                  ) : (
                                    <span className="not-selected"></span>
                                  )}
                                </div>
                                <div
                                  className="depedent-select-list display-flex"
                                  onClick={() =>
                                    this.handleChange(
                                      "isfulldayabsentpenalty",
                                      true,
                                    )
                                  }
                                  aria-expanded={
                                    this.state.isfulldayabsentpenalty
                                  }
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <span>No (Mark the employee as absent)</span>
                                  {this.state.isfulldayabsentpenalty ? (
                                    <span className="floatright">
                                      <img src={CheckImg} height="20" />
                                    </span>
                                  ) : (
                                    <span className="not-selected"></span>
                                  )}
                                </div>
                              </li>
                            </ul>
                          </Collapse>
                        </div>
                      </Collapse>
                    </div>
                    <div
                      className="depedent-select-list"
                      onClick={() =>
                        this.handleChange(
                          "isforweekly",
                          !this.state.isforweekly,
                        )
                      }
                      aria-expanded={this.state.isforweekly}
                    >
                      <span>
                        <FormattedMessage
                          id="LbMinHoursaWeek"
                          defaultMessage="Employees are required to work minimum hours, every week"
                        />
                      </span>
                      {this.state.isforweekly ? (
                        <span className="floatright selected-box">
                          {" "}
                          <svg width="24" height="24" viewBox="0 0 24 24">
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                          </svg>
                        </span>
                      ) : (
                        <span className="not-selected-box"></span>
                      )}
                    </div>
                    <div className="et-level3">
                      <Collapse
                        in={this.state.isforweekly}
                        timeout={2}
                        unmountOnExit
                        className="padding30 overflow-initial"
                      >
                        <ul>
                          <li className="margin-bottom-16">
                            <span>
                              <FormattedMessage
                                id="LbForFullWorkingWeek"
                                defaultMessage="Required time-at-work or hours for one week, and penalty (if any) in case of deficit"
                              />
                              <br />
                              <span className="width200p">
                                <InputValues
                                  min="0"
                                  max="99"
                                  field="hoursweekly"
                                  onChange={this.handleChange.bind(
                                    this,
                                    "hoursweekly",
                                    99,
                                  )}
                                  value={this.state.hoursweekly}
                                  defaultvalue={this.state.hoursweekly}
                                />
                              </span>
                              <FormattedMessage
                                id="LbHours"
                                defaultMessage="hours"
                              />
                              <InputValues
                                min="0"
                                max="59"
                                field="minutesweekly"
                                onChange={this.handleChange.bind(
                                  this,
                                  "minutesweekly",
                                  59,
                                )}
                                value={this.state.minutesweekly}
                                defaultvalue={this.state.minutesweekly}
                              />

                              <FormattedMessage
                                id="LbMinutes"
                                defaultMessage="minutes"
                              />
                            </span>
                          </li>
                          <li className="margin-bottom-16">
                            <span className="display-block margin-bottom-8">
                              <FormattedMessage
                                id="LbPenaltyMinHours"
                                defaultMessage="Do you want to deduct leaves as penalty if the employee is unable to complete the required minimum hours?"
                              />
                            </span>
                            <div
                              className="depedent-select-list"
                              onClick={() =>
                                this.handleChange("isweeklypenalty", true)
                              }
                              aria-expanded={this.state.isweeklypenalty}
                            >
                              <span>
                                <FormattedMessage
                                  id="LbYes"
                                  defaultMessage="Yes"
                                />
                              </span>
                              {this.state.isweeklypenalty ? (
                                <span className="floatright">
                                  <img src={CheckImg} height="20" />
                                </span>
                              ) : (
                                <span className="not-selected"></span>
                              )}
                            </div>
                            <Collapse
                              in={this.state.isweeklypenalty}
                              timeout={2}
                              unmountOnExit
                              className="padding30 overflow-initial"
                            >
                              <div className="et-level4">
                                <ul className="padding20 padding-left-40">
                                  <li>
                                    <p className="form-input-label">
                                      <FormattedMessage
                                        id="LbChooseleavetype"
                                        defaultMessage="Choose leave type "
                                      />
                                    </p>
                                    <span className="width200p">
                                      <Select
                                        autofocus
                                        placeholder="Select"
                                        options={this.state.LeaveType}
                                        getOptionLabel={(option) =>
                                          option.displayname
                                        }
                                        getOptionValue={(option) =>
                                          option.displayvalue
                                        }
                                        onChange={this.handleChange.bind(
                                          this,
                                          "weeklyleaveid",
                                        )}
                                        value={this.state.weeklyleaveid}
                                        className="width200p"
                                      />
                                    </span>
                                  </li>
                                  <li className="margin-top-20">
                                    <p className="form-input-label">
                                      <FormattedMessage
                                        id="LbNumberLeaveDeduct"
                                        defaultMessage="Number of leaves to deduct"
                                      />
                                    </p>
                                    <FloatValues
                                      min="0"
                                      max="31"
                                      step="0.25"
                                      field="weeklyleavecount"
                                      onChange={this.handleChange.bind(
                                        this,
                                        "weeklyleavecount",
                                        31,
                                      )}
                                      value={this.state.weeklyleavecount}
                                      defaultvalue={this.state.weeklyleavecount}
                                    />
                                  </li>
                                  <li className="margin-top-10">
                                    <p className="form-input-label">
                                      <FormattedMessage
                                        id="LbDeductionPolicy"
                                        defaultMessage="Deduction Policy"
                                      />
                                    </p>
                                    {/* <ul className="padding-left-20">
                                                                        <li> */}
                                    <div
                                      className="depedent-select-list"
                                      onClick={() =>
                                        this.handleChange(
                                          "weeklypenaltyactiontypeid",
                                          1,
                                        )
                                      }
                                      aria-expanded={
                                        this.state.weeklypenaltyactiontypeid ==
                                        1
                                      }
                                    >
                                      <div
                                        style={{
                                          width: "90%",
                                          display: "inline-block",
                                        }}
                                      >
                                        <FormattedMessage
                                          id="LbAutoDeductLeave"
                                          defaultMessage="Automatically send a leave request on behalf of the employee, using the regular Leave approval workflow"
                                        />
                                      </div>
                                      {this.state.weeklypenaltyactiontypeid ==
                                      1 ? (
                                        <div
                                          style={{ display: "inline-block" }}
                                          className="floatright margin-top-20"
                                        >
                                          <img src={CheckImg} height="20" />
                                        </div>
                                      ) : (
                                        <div className="not-selected margin-top-20"></div>
                                      )}
                                    </div>
                                    {/* </li>
                                                                        <li> */}
                                    <div
                                      className="depedent-select-list"
                                      onClick={() =>
                                        this.handleChange(
                                          "weeklypenaltyactiontypeid",
                                          2,
                                        )
                                      }
                                      aria-expanded={
                                        this.state.weeklypenaltyactiontypeid ==
                                        2
                                      }
                                    >
                                      <div
                                        style={{
                                          width: "90%",
                                          display: "inline-block",
                                        }}
                                      >
                                        <FormattedMessage
                                          id="LbExceedingGraceHours"
                                          defaultMessage="Deduct automatically and notify employee, approvers and admin"
                                        />
                                      </div>
                                      {this.state.weeklypenaltyactiontypeid ==
                                      2 ? (
                                        <div
                                          style={{ display: "inline-block" }}
                                          className="floatright"
                                        >
                                          <img src={CheckImg} height="20" />
                                        </div>
                                      ) : (
                                        <div className="not-selected"></div>
                                      )}
                                    </div>
                                    {/* </li>
                                                                    </ul> */}
                                  </li>
                                </ul>
                              </div>
                            </Collapse>
                            <div
                              className="depedent-select-list display-flex"
                              onClick={() =>
                                this.handleChange("isweeklypenalty", false)
                              }
                              aria-expanded={!this.state.isweeklypenalty}
                              style={{ justifyContent: "space-between" }}
                            >
                              <span>
                                No (Manager will be notified about this breach
                                but no action will be taken)
                              </span>
                              {!this.state.isweeklypenalty ? (
                                <span className="floatright">
                                  <img src={CheckImg} height="20" />
                                </span>
                              ) : (
                                <span className="not-selected"></span>
                              )}
                            </div>
                          </li>
                        </ul>
                      </Collapse>
                    </div>
                  </Collapse>
                </div>
              </div>
              <div>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("istimeatworkrule", false)}
                  aria-expanded={!this.state.istimeatworkrule}
                >
                  <div style={{ width: "95%", display: "inline-block" }}>
                    <FormattedMessage
                      id="LbNoTAW"
                      defaultMessage="No, there is no time-at-work requirement. Employees can spend any amount of time at work, even if it's less than their stipulated shift-duration"
                    />
                  </div>
                  {!this.state.istimeatworkrule ? (
                    <div
                      style={{ display: "inline-block" }}
                      className="floatright margin-top-10"
                    >
                      <img src={CheckImg} height="20" />
                    </div>
                  ) : (
                    <div className="not-selected  margin-top-10"></div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}

TimeAtWork.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitAttendancePolicy: state.InitAttendancePolicy,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      AttendancePolicyData: (data) => AttendancePolicyData(data),
      CommonReducerAction: (data) => CommonReducerAction(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(TimeAtWork)));
